/**
 * jrs-error-telemetry.js — one dataLayer event for every customer-facing
 * failure outside the customiser popup (the popup family keeps its own
 * pdp_customizer_* names via JRS.CustomizerPopup.fireAnalytics).
 *
 * Event: `jrs_customer_error`
 *   surface     — 'cart' | 'pdp' | 'bundle_grid' | 'enquiry' | 'trade_account' | 'cart_edit' | 'checkout'
 *   error_key   — stable snake_case key for the failure (grep-able in code)
 *   message     — the text the shopper saw ('' when the failure is silent)
 *   silent      — true when nothing was shown to the shopper
 *   http_status — when a fetch was involved (0 = network)
 *   detail      — short system string (Shopify description / exception message); never user content
 *   page_path, device_type — added here
 *
 * Pipeline: dataLayer ONLY (needs one GTM trigger: Custom Event `jrs_customer_error`).
 * Deliberately not gtag-direct so it cannot double once routed.
 * Fail-silent: this module must never throw into the caller.
 */
window.JRS = window.JRS || {};
(function (JRS) {
  'use strict';
  var _count = 0;
  function report(surface, errorKey, params) {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
      var p = params || {};
      var payload = {
        event: 'jrs_customer_error',
        surface: String(surface || 'unknown'),
        error_key: String(errorKey || 'unknown'),
        message: typeof p.message === 'string' ? p.message.slice(0, 200) : '',
        silent: p.silent === true,
        http_status: (typeof p.http_status === 'number') ? p.http_status : null,
        detail: typeof p.detail === 'string' ? p.detail.slice(0, 200) : '',
        page_path: (window.location && window.location.pathname) || '',
        device_type: (window.innerWidth < 750) ? 'mobile' : 'desktop',
        error_seq: ++_count,
        theme_build: String(window._bcThemeVersion || window.JRS_BUILD_ID || '') || null // v8.2.0 — from the theme stamp, never a literal
      };
      for (var k in p) {
        if (Object.prototype.hasOwnProperty.call(p, k) && !(k in payload) && k !== 'event') {
          var v = p[k];
          if (v === null || typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') payload[k] = v;
        }
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) { /* never throw into the caller */ }
  }
  JRS.ErrorTelemetry = { report: report, VERSION: '1.0.0' };
})(window.JRS);
